import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import * as styles from './styles/styles.module.scss';
import OutlinedTextField from '../../forms/textFields/OutlinedTextField';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import FormButton from '../../forms/FormButton';

class TrailDetailItemForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.text
    };
  }

  handleChange = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    this.setState({ text: e.currentTarget.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    this.props.handleSubmit(this.state.text);
  };

  renderFormButtons = () => {
    return (
      <div className={styles.buttonContainer}>
        <FormButton value={StringConstantsMixin.strings.SUBMIT} disabled={this.props.submitting} />
        <Button onClick={this.props.handleCancelPress} text={StringConstantsMixin.strings.CANCEL} testId="trail-item-form-cancel" variant="flat" />
      </div>
    );
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <OutlinedTextField
          name="description"
          errorMessage=""
          value={this.state.text}
          label={this.props.label}
          changeHandler={this.handleChange}
          multiline
          verticalResize
          rows={8}
        />
        {this.renderFormButtons()}
      </form>
    );
  }
}

TrailDetailItemForm.propTypes = {
  maxLength: PropTypes.number,
  text: PropTypes.string,
  handleCancelPress: PropTypes.func,
  handleSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
  submitting: PropTypes.bool,
  label: PropTypes.string
};

export default TrailDetailItemForm;
